<script setup lang="ts">
const route = useRoute()
defineProps({
  embedded: {
    type: Boolean,
    default: false
  }
})
const showEmbeddedFooter = computed(() => {
  return route.path.startsWith('/ch/com')
})
</script>
<template>
  <footer v-if="!showEmbeddedFooter || (showEmbeddedFooter && embedded)" class="grid grid-cols-1 gap-4 items-center px-4 py-4 mt-4 w-full border-t print:!hidden bg-secondary-20 border-gray-20 sm:gap-0" :class="[!embedded ? 'sm:flex sm:px-12' : 'sm:flex sm:px-12 lg:px-0']">
    <div class="flex flex-col sm:flex-row sm:items-center">
      <span class="text-gray-50 typo-s">&copy; Orell Füssli AG {{ new Date().getFullYear() }}</span>
    </div>
    <div class="flex justify-end sm:ml-auto">
      <NuxtLink to="/help" class="typo-s text-gray-85">
        Hilfe
      </NuxtLink>
      <NuxtLink to="/content" class="ml-4 md:ml-12 typo-s text-gray-85">
        Inhalte
      </NuxtLink>
      <a href="https://ofjus.ch/impressum" target="_blank" class="ml-4 md:ml-12 typo-s text-gray-85">
        Impressum
      </a>
      <a href="https://ofjus.ch/datenschutzerklaerung" target="_blank" class="ml-4 md:ml-12 typo-s text-gray-85">
        Datenschutz
      </a>
      <a href="https://myaccount.ofjus.ch/legal/agb" target="_blank" class="ml-4 md:ml-12 typo-s text-gray-85 hidden md:inline-block">
        AGB
      </a>
    </div>
  </footer>
  <div v-if="!embedded" class="print:!hidden w-full h-1 bg-brand-mustard-500" />
</template>
